// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cA9IyN0aEeocOAWRpVL0{width:290px}.ZVVev_cRfkEheu_qujXd{border-top:1px var(--border-neutral-default)solid;padding:4px}.M1LJ8MykWZ0IEnVTYUIF,.ZDxGMrbioE8Fx4g3I2AV{justify-content:center;align-items:center;padding:15px;display:flex}.zXJ0aU7nRB8cyCRKajKS{height:100%;color:var(--content-primary-primary);text-overflow:ellipsis;padding:4px;font-size:13px;font-weight:400}.EEnxymmGmUiJ6f6e5dWi{background:var(--background-primary-inverted-primary);border:none;border-radius:6px;outline:none;padding:12px}.FL6zOPuOnLoV_1Pwximw{border-bottom:1px solid var(--border-neutral-default)}.Q_VqLdmQTg5J9oagP1WE{background-color:var(--border-neutral-default);width:100%;height:1px;margin:4px 0}.LcAKehudKGAwjiCNp0KF{color:var(--gray-60);justify-content:center;align-items:center;padding:15px;display:flex}.aNLMeduKfL42GT4BVXBw{padding:8.5px 12px;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `cA9IyN0aEeocOAWRpVL0`,
	"clear": `ZVVev_cRfkEheu_qujXd`,
	"spinner": `M1LJ8MykWZ0IEnVTYUIF`,
	"epmtyList": `ZDxGMrbioE8Fx4g3I2AV`,
	"list": `zXJ0aU7nRB8cyCRKajKS`,
	"search": `EEnxymmGmUiJ6f6e5dWi`,
	"searchWrap": `FL6zOPuOnLoV_1Pwximw`,
	"divider": `Q_VqLdmQTg5J9oagP1WE`,
	"emptyList": `LcAKehudKGAwjiCNp0KF`,
	"limitInfo": `aNLMeduKfL42GT4BVXBw`
};
export default ___CSS_LOADER_EXPORT___;
